import React from 'react';
import ReactDOM from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import './assets/style.css'

import App from './App';
import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from 'react-bootstrap';
import {Provider} from 'react-redux';
import {createStore} from 'redux';
import rootReducers from './store/reducers';
import Login from "./pages/auth";
import {BrowserRouter, Route, Routes} from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById('root'));
const store = createStore(rootReducers)

root.render(
    <Provider store={store}>
        <ThemeProvider dir="rtl">
            <BrowserRouter>
                <Routes>
                    <Route index element={<App/>}/>
                </Routes>
            </BrowserRouter>

        </ThemeProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
